import React, { useEffect, useRef } from 'react';

import { bemCssModules, getTestId } from '@utils';
import { useIntersectionObserver } from '@utils/hooks';

import { transactionsActions, useStore } from '@modules';
import { CryptoCurrencyEnum } from '@modules/global/types';

import Spinner from '@components/Spinner';

import Table from './Table';

import style from './Transactions.scss';

const cn = bemCssModules(style, 'Transactions');
const ti = getTestId('Transactions');

export type LoadMoreParamsType = {
  fullyLoaded: boolean;
  isLoading: boolean;
  offset: number;
};

const loadMoreParams: LoadMoreParamsType = {
  fullyLoaded: false,
  isLoading: false,
  offset: 0,
};

export type TTransactions = {
  title?: string;
  currency?: CryptoCurrencyEnum;
  limit?: number;
};

export const Transactions: CustomFC<TTransactions> = props => {
  const { className, title, currency } = props;
  const ref = useRef<HTMLDivElement>(null);

  const [{ transactions }, dispatch] = useStore();
  const { list, loaders, total } = transactions;

  const isLoadingGetTransactions = loaders.getTransactions;

  let offset = 0;
  Object.keys(list).forEach(day => {
    offset += Object.keys(list[day]).length;
  });
  const fullyLoaded = total === offset && !isLoadingGetTransactions;
  const params = { fullyLoaded, isLoading: isLoadingGetTransactions, offset };
  Object.keys(params).forEach(key => (loadMoreParams[key] = params[key]));

  const getMoreTransactions = () => {
    if (loadMoreParams.fullyLoaded || loadMoreParams.isLoading) return;
    dispatch(transactionsActions.getTransactions({ currency, offset: loadMoreParams.offset }));
  };

  useIntersectionObserver(ref.current, getMoreTransactions);

  useEffect(() => {
    dispatch(transactionsActions.getTransactions({ currency }));
    return () => {
      dispatch(transactionsActions.resetTransactions());
    };
  }, []);

  if (!isLoadingGetTransactions && !offset) return null;

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      {title && <h2 className={cn('title')}>{title}</h2>}
      <Table />
      {isLoadingGetTransactions && (
        <div className={cn('loader')}>
          <Spinner size={30} className={cn('spinner')} />
        </div>
      )}
      {!fullyLoaded && <div ref={ref}></div>}
    </div>
  );
};

export default Transactions;
